import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText
} from '@material-ui/core';

export default function TermsOfUseCheckbox({
    isDisabled,
    hasAgreed,
    hasAgreedError,
    onChange
}) {
    return (
        <div
            className="terms-checkbox-container"
            data-testid="terms-of-use-checkbox"
        >
            <FormControl error={hasAgreedError}>
                <FormControlLabel
                    required
                    control={
                        <Checkbox
                            checked={hasAgreed}
                            onChange={onChange}
                            disabled={isDisabled}
                        />
                    }
                    label={
                        <div className="terms-container narrow body1">
                            <span>
                                I have read and agree to the &nbsp;
                                <a
                                    href="https://legal.trainheroic.com/terms-of-use.html"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="terms-link"
                                >
                                    Terms of Use
                                </a>{' '}
                                and{' '}
                                <a
                                    href="https://legal.trainheroic.com/privacy-policy.html"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="terms-link"
                                >
                                    Privacy&nbsp;Policy
                                </a>
                                .
                            </span>
                        </div>
                    }
                />
                {hasAgreedError &&
                    !isDisabled && (
                        <FormHelperText error>
                            Please check the box to continue
                        </FormHelperText>
                    )}
            </FormControl>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/v5/termsOfUse/components/TermsOfUseCheckbox.js